import axios from "axios";
import { getWhatsAppGoUrl } from "../config";
import {
	clearStoredToken,
	getStoredToken,
	refreshAccessToken,
	shouldAttemptTokenRefresh,
} from "./authToken";

const apiV2 = axios.create({
	withCredentials: false,
});

function companyIdFromToken(tok) {
	if (!tok) return null;
	const parts = tok.split(".");
	if (parts.length < 2) return null;
	try {
		const payload = JSON.parse(
			atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"))
		);
		const id = payload?.companyId;
		if (id == null || id === "") return null;
		return id;
	} catch {
		return null;
	}
}

function applyBearer(config, token) {
	if (!token) return;
	config.headers = config.headers || {};
	if (typeof config.headers.set === "function") {
		config.headers.set("Authorization", `Bearer ${token}`);
	} else {
		config.headers.Authorization = `Bearer ${token}`;
	}
}

apiV2.interceptors.request.use((config) => {
	const base = getWhatsAppGoUrl();
	config.baseURL = `${base}/api/v2`;

	applyBearer(config, getStoredToken());

	const companyId = companyIdFromToken(getStoredToken());
	if (
		companyId != null &&
		(config.params == null || config.params.companyId == null)
	) {
		config.params = { ...(config.params || {}), companyId };
	}

	return config;
});

apiV2.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config;
		if (!originalRequest || originalRequest._retry) {
			return Promise.reject(error);
		}

		if (!shouldAttemptTokenRefresh(error)) {
			return Promise.reject(error);
		}

		originalRequest._retry = true;
		try {
			const data = await refreshAccessToken();
			applyBearer(originalRequest, data.token);
			return apiV2(originalRequest);
		} catch {
			clearStoredToken();
			return Promise.reject(error);
		}
	}
);

export default apiV2;
